import { Reducer } from 'react';

import { INewsInformationePayload, INewsInformationResponses } from '../../utils/types/admin-types';
import {
  Action,
} from '../../utils/types/state-types';
import {
  GET_DIVISION_RECEIVED,
  GET_DIVISION_REJECTED,
  GET_DIVISION_REQUESTED,
} from '../actions/main-page';

export interface INewsInformationState {
  error?: string;
  responses: INewsInformationResponses ;
  isLoading: boolean;
}

const initialState = {
  responses: {},
  error: '',
  isLoading: false,
} as INewsInformationState;

const newsDivisionReducer: Reducer<INewsInformationState, Action> = (
  state = initialState,
  action: Action,
) => {
  const { type } = action;
  switch (type) {
    case GET_DIVISION_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case GET_DIVISION_RECEIVED: {
      const { payload } = action as Action<INewsInformationePayload>;
      return {
        ...state,
        isLoading: false,
        responses: payload.division,
        error: '',
      };
    }
    case GET_DIVISION_REJECTED: {
      const { payload } = action as Action<INewsInformationePayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    default:
      return state;
  }
};

export default newsDivisionReducer;
